// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"de606e7046228d7090d3","522":"95f45b6bc8e8f1dd25c4"}[chunkId] + ".js";
};